// removed by extract-text-webpack-plugin
module.exports = {"image":"src-components-ui----ScreenedImageCover-module---image---2xRFb"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/ScreenedImageCover.module.scss
// module id = 405
// module chunks = 151087471038741 164721891013254